import React from "react";
import { useLanguage } from "../Translations/LenguageContext";

const Paper = () => {
    const { t } = useLanguage()

    return (
        <div className="brain_cont fade-in">
            <h3>{t.architecture.title}</h3>
            <p className="brain_card_desc" dangerouslySetInnerHTML={{__html: `${t.paper.content}`}}></p>
        </div>
    )
}

export default Paper